export default __webpack_public_path__ + "static/media/highlightOrange.ed8ba64d.svg";